import { Col } from 'react-bootstrap';
import styled from 'styled-components';

export const PropertyActionsColumnStyled = styled(Col).attrs(() => ({
  xs: 12,
  md: 7,
}))`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;
  gap: 8px;
  z-index: 0;

  > div {
    display: flex;
    gap: 8px;
    align-items: center;
  }
`;
